import React from "react";
var __jsx = React.createElement;
import stl from "./AsideFooter.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
function AsideFooter(_ref) {
  var setFilterOnMobile = _ref.setFilterOnMobile,
    count = _ref.count,
    selectedFiltersCount = _ref.selectedFiltersCount;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, count == 0 && selectedFiltersCount > 0 && /*#__PURE__*/React.createElement("div", {
    id: "filter-footer-note",
    className: stl.noteContainer
  }, /*#__PURE__*/React.createElement("strong", null, t("try_removing_filters", {
    ns: "web_search"
  })), " ", /*#__PURE__*/React.createElement("span", null, t("find_matching_search_results", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("div", {
    className: [stl.container, "m-show"].join(" "),
    id: "clickMeToCloseFilter",
    onClick: function onClick() {
      setFilterOnMobile(false);
      document.body.style.overflow = "";
    }
  }, /*#__PURE__*/React.createElement("strong", null, t("show_results", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    width: 18,
    height: 12,
    src: CDN_LINK + "/assets/images/arrShow.svg",
    alt: "arrow"
  }))));
}
export default AsideFooter;